export const PlatformExeptions = (platformName) => {
  let platform = platformName;
  switch (platform) {
    case 'lewagon':
      platform = 'LeWagon';
      break;
    case 'demo-universidades':
      platform = 'demo';
      break;
    case 'localhost':
      // platform = 'demo';
      platform = 'bolsadetrabajo';
      break;
    case 'ucpuebla':
      platform = 'cuahutemoc';
      break;
    case 'tecdeoriente':
      platform = 'utdo';
      break;
    case 'utlaguna':
      platform = 'utlagunadurango';
      break;
    case 'wadhwaniorg':
      platform = 'wadhwani';
      break;
    case 'imef':
      platform = 'imefu';
      break;
    case 'utm':
      platform = 'utmezquital';
      break;
    case 'bolsaexpansion.utel.edu.mx':
      platform = 'utel';
      break;
    case 'somosresilientes.savethechildren.mx':
      platform = 'savethechildren';
      break;
    case 'bolsa.savethechildren':
      platform = 'savethechildren';
      break;
    default:
      platform = platformName;
      break;
  }
  return platform;
};

export const bodyAdminMailNotification = (
  platform,
  platformName,
  contact,
  adminName,
  platformUrl,
  companyName,
  vacancyName
) =>
  platform.customEmails
    ? {
        fromEmail: `${platform.fromEmail}`,
        destiny: `${contact}`,
        subject: `${companyName} agregó la vacante ${vacancyName}`,
        body: `<p style="font-size: 18px; font-weight: 600;">Hola ${adminName},</p>
        <br />
        <p style="font-size: 18px;">Una nueva vacante está pendiente de tu aprobación para 
        aparecer en su bolsa de trabajo. Al publicarse, toda tu comunidad podrá verla y aplicar.
        No esperes para revisarla y darla de alta:</p>
        <br />
        <a styles="font-size: 18px" href="${platformUrl}/management">
        <p style="font-size: 18px;">Iniciar sesión ahora</p>
        </a>
        <br />
        <p style="font-size: 18px;">Saludos, <br />
        El equipo de lapieza.io</p>
        <br />
        <img width="140px" src=${platform.customEmailsLogo} />
        <br />
        <p style="font-size: 14px;">¿Ya nos sigues?</p>
        <br />
           ${
             platform.facebookLink &&
             `<a styles="margin: 7px" href=${platform.facebookLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                 </a>`
           }
           ${
             platform.twitterLink &&
             `<a styles="margin: 7px" href=${platform.twitterLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                </a>`
           }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }
            `,
      }
    : {
        destiny: `${contact}`,
        subject: `${companyName} agregó la vacante ${vacancyName}`,
        body: `<p style="font-size: 18px; font-weight: 600;">Hola ${adminName},</p>
        <br />
        <p style="font-size: 18px;">Una nueva vacante está pendiente de tu aprobación para 
        aparecer en su bolsa de trabajo. Al publicarse, toda tu comunidad podrá verla y aplicar.
        No esperes para revisarla y darla de alta:</p>
        <br />
        <a styles="font-size: 18px" href="${platformUrl}/management">
        <p style="font-size: 18px;">Iniciar sesión ahora</p>
        </a>
        <br />
        <p style="font-size: 18px;">Saludos, <br />
        El equipo de lapieza.io</p>
        <br />
        <img width="140px" src="https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29" />
        <br />
        <p style="font-size: 14px;">¿Ya nos sigues?</p>
        <br />
        <a styles="margin: 7px" href="https://www.facebook.com/lapieza.io/">
            <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png">
        </a>
        <a styles="margin: 7px" href="https://twitter.com/lapiezaio?lang=es">
            <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png">
        </a>
        <a styles="margin: 7px" href="https://www.instagram.com/lapieza.io/">
            <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png">
        </a>
        <a styles="margin: 7px" href="https://ar.linkedin.com/company/lapieza">
            <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png">
        </a>`,
      };

export const FormatTextEmail = (
  body = '',
  Change = {
    COMPANY: 'Company',
    VACANCY: 'Name vacancy',
    CANDIDATE: 'Carlos Antonio',
  },
  styleChange = [
    {
      key: 'class="ql-align-center"',
      change: 'style="text-align: center !important"',
    },
    {
      key: 'class="ql-align-justify"',
      change: 'style="text-align: justify !important"',
    },
    {
      key: 'class="ql-align-right"',
      change: 'style="text-align: right !important"',
    },
  ]
) => {
  let text = body;
  console.log(Change);
  Object.keys(Change).map((e) => {
    console.log(e);
    const regex = new RegExp(`{${e}}`, 'gi');
    text = text.replace(regex, Change[e]);
    return null;
  });
  Object.values(styleChange).map((e) => {
    const regex = new RegExp(`${e.key}`, 'gi');
    text = text.replace(regex, e.change);
    return null;
  });

  return text;
};

export const bodyMailNotification = (
  platform,
  logo = 'https://firebasestorage.googleapis.com/v0/b/pieza-development.appspot.com/o/general%2F1389x362%20(1).png?alt=media&token=50eeb7a8-e98d-47e8-9b22-f695bd38e1b8',
  body,
  destiny,
  subject,
  changeValues,
  farewell = '',
  logoFooter = '',
  link = ''
) => {
  return platform.customEmails
    ? {
        fromEmail: `${platform.fromEmail}`,
        destiny: `${destiny}`,
        subject: FormatTextEmail(subject, changeValues),
        body: `<div style="
        height: fit-content;
        width: 75vh;
        display: grid;
        align-items: center;
        justify-items: center;
        margin-left: 100px;
        font-family: sans-serif;
      ">
      <div>
        ${FormatTextEmail(body, changeValues)}
      </div>
      <a href="${link}"
         style="
            justify-self: center!important;
            margin: 8px auto!important;
            color: white;
            background-color: #5373fc;
            padding: 8px 64px;
            border-radius: 4px;
            font-family: sans-serif;
            text-decoration: none;
            width: 180px;
            text-align: center;
      " >Abrir</a>
      <img src="${platform.customEmailsLogo}" style="
            justify-self: center!important;
            margin: 8px auto !important;
            width: 20%;
            height: auto!important;
        "/>
        <div style="
        display: flex;
        flex-direction: row!important;
        align-items: center!important;
        margin: 0 auto!important;
      " >
            ${
              platform.facebookLink &&
              `<a styles="margin: 7px" href=${platform.facebookLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                </a>`
            }
           ${
             platform.twitterLink &&
             `<a styles="margin: 7px" href=${platform.twitterLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                </a>`
           }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }
        </div>
    </div>
    `,
        logoFooter,
        farewell,
      }
    : {
        destiny: `${destiny}`,
        subject: FormatTextEmail(subject, changeValues),
        body: `<div style="
        height: fit-content;
        width: 75vh;
        display: grid;
        align-items: center;
        justify-items: center;
        margin-left: 100px;
        font-family: sans-serif;
      ">
      <div>
        ${FormatTextEmail(body, changeValues)}
      </div>
      <a href="${link}"
         style="
            justify-self: center!important;
            margin: 8px auto!important;
            color: white;
            background-color: #5373fc;
            padding: 8px 64px;
            border-radius: 4px;
            font-family: sans-serif;
            text-decoration: none;
            width: 180px;
            text-align: center;
      " >Abrir</a>
      <img src="${logoFooter || logo}" style="
            justify-self: center!important;
            margin: 8px auto !important;
            width: 20%;
            height: auto!important;
        "/>
        <div style="
        display: flex;
        flex-direction: row!important;
        align-items: center!important;
        margin: 0 auto!important;
      " >
            <a style="margin: 7px;" href='https://www.facebook.com/lapieza.io/'>
                <img style="margin: 8px; width:40px;" src='https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png'/>
            </a>
            <a style="margin: 7px;" href='https://twitter.com/lapiezaio?lang=es'>
                <img style="margin: 8px; width:40px;" src='https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png'/>
            </a>
            <a style="margin: 7px;" href='https://www.instagram.com/lapieza.io/'>
                <img style="margin: 8px; width:40px;" src='https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png'/>
            </a>
            <a style='margin: 7px' href='https://ar.linkedin.com/company/lapieza'>
                <img style="margin: 8px; width:40px;" src='https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png'/>
            </a>
        </div>
    </div>
    `,
        logoFooter,
        farewell,
      };
};
